import type { UseQueryOptions } from 'react-query';

import {
  eventLeadsApiKeys,
  useEventLeadsApi,
} from '../../../../hooks/api/event-leads/useEventLeadsApi';
import { useGetApi } from '../../../../hooks/api/useGetApi';
import type { EventLeadTicket } from '../../../../types/events/leads';

export function useEventLeadsStatus(
  organizationId: string,
  options?: UseQueryOptions<EventLeadTicket>
) {
  const api = useEventLeadsApi();

  return useGetApi({
    enabled: !!organizationId,
    queryKey: eventLeadsApiKeys.isRunningTicket(organizationId),
    request: () => api.isRunningTicket(organizationId),
    ...options,
  });
}
